import React from "react";
import {
  CardContainer,
  CardContentContainer,
  CardEmoji,
  CardNumber,
  CardParagraph,
  IconContainer,
} from "./styles";
import Icon, {
  getIconType,
} from "../../../../../../../../../components/ui/icon/Icon";
import { useTheme } from "styled-components";
import { CARDS_PROP } from "../../../../../../settings/features/cards/defaults";
import EditableText from "../../inline-edit/EditableText";
import EditableInput from "../../inline-edit/EditableInput";

function NumberTwo({ data, config, isEditable }) {
  const iconType = getIconType(data.icon);

  const theme = useTheme();

  const accentColor = data[CARDS_PROP.COLORS].accent[theme.name];
  const textColor = data[CARDS_PROP.COLORS].text[theme.name];

  return (
    <CardContainer
      borderRadius={config.borderRadius}
      backgroundColor={accentColor}
    >
      {config.layout.includes(CARDS_PROP.ICON) && (
        <IconContainer backgroundColor={textColor} color={accentColor}>
          {iconType === "emoji" && <CardEmoji>{data.icon.native}</CardEmoji>}

          {iconType === "icon" && <Icon icon={data.icon} />}

          {iconType === "app" && <img src={data.icon} alt="img" height="100" />}
        </IconContainer>
      )}

      <CardContentContainer>
        <CardNumber color={textColor}>
          {isEditable ? (
            <EditableInput
              inputProp={CARDS_PROP.NUMBER}
              data={data}
              config={config}
              customStyles={{ textAlign: "left" }}
            />
          ) : (
            data.number
          )}
        </CardNumber>
        {config.layout.includes(CARDS_PROP.TEXT) && (
          <CardParagraph color={textColor}>
            {isEditable ? (
              <EditableText
                data={data}
                config={config}
                inputProp={CARDS_PROP.TEXT}
                customCalculatorStyles={{ minHeight: "1em" }}
              />
            ) : (
              data.text
            )}
          </CardParagraph>
        )}
      </CardContentContainer>
    </CardContainer>
  );
}

export default NumberTwo;
